module.exports = __webpack_public_path__ + "img/番泻叶.5153ff24.jpg";